import React, { useEffect, useState } from "react";
import useAxiosInstance from "../../hooks/useAxios";
import { toast } from "react-toastify";
import Select from "react-select";
import DataSynthesisImg from "../../assests/DataSynthesis.svg";
import marketMapImg from "../../assests/ShopIcon.svg";
import companyDeepDiveImg from "../../assests/companyDeepDive.svg";
import customInsightsImg from "../../assests/customInsights.svg";
import lockImg from "../../assests/lock.svg";
import peerAnalysisImg from "../../assests/peerAnalysis.svg";
import sectorSnapshotImg from "../../assests/sectorSnapshot.svg";
import portfolioMonitoringIcon from "../../assests/portfolioMonitoringIcon.svg";
import Card from "./component/card";
import { Spinner } from "flowbite-react";
import { useSearchParams } from "react-router-dom";
import { Fa0 } from "react-icons/fa6";
import { useSelector } from "react-redux";
import DashboardCardRound from "./component/card";
import FormRender from "../../components/FormRender";
export const workflowCardsMetaData = {
  dataRoomSynthesis_v2: {
    icon: "https://wkemails.blob.core.windows.net/fe-application/Data room synthesis.svg",
    lexicalFeatures: {
      source_modal: true,
      file_types_in_source_modal: true,
      add_question: true,
    },
  },
  qna: {
    icon: "https://wkemails.blob.core.windows.net/fe-application/Industry Q&A.svg",
  },
  qna_v2: {
    icon: "https://wkemails.blob.core.windows.net/fe-application/Industry Q&A.svg",
    lexicalFeatures: {
      show_articles: true,
      add_question: true,
      qna_advance_config: true,
    },
  },
  qna_v2_files: {
    icon: "https://wkemails.blob.core.windows.net/fe-application/Multi-file Q&A .svg",
    lexicalFeatures: {
      source_modal: true,
      file_types_in_source_modal: false,
      add_question: true,
    },
  },
  company_qna: {
    icon: "https://wkemails.blob.core.windows.net/fe-application/Multi-file Q&A .svg",
  },
  marketMap: {
    icon: "https://wkemails.blob.core.windows.net/fe-application/ShopIcon.svg",
  },
  market_map_v2: {
    icon: "https://wkemails.blob.core.windows.net/fe-application/ShopIcon.svg",
  },
  recentStrategy_v2: {
    icon: "https://wkemails.blob.core.windows.net/fe-application/Company primer.svg",
  },
  sectorSnapshot: {
    icon: "https://wkemails.blob.core.windows.net/fe-application/industry primer.svg",
  },
  sectorSnapshot_v3: {
    icon: "https://wkemails.blob.core.windows.net/fe-application/industry primer.svg",
    lexicalFeatures: {
      add_question: true,
    },
  },
  concise_company_primer: {
    icon: "https://wkemails.blob.core.windows.net/fe-application/premeeting brief.svg",
    lexicalFeatures: {
      add_question: false,
    },
  },
  newsletter: {
    icon: "https://wkemails.blob.core.windows.net/fe-application/Newsfeed.svg",
    url: "/dashboard/newsletter",
  },
  recentStrategy: {
    icon: "https://wkemails.blob.core.windows.net/fe-application/Company primer.svg",
  },
  dataRoomSynthesis: {
    icon: "https://wkemails.blob.core.windows.net/fe-application/Company primer.svg",
  },
  competitive_analysis: {
    icon: "https://wkemails.blob.core.windows.net/fe-application/Competitive landscape.svg",
  },
};
const DashboardTiles = () => {
  const [orgPk, setOrgPk] = useState(1);
  const [isAdmin, setIsAdmin] = useState(false);
  const [orgName, setOrgName] = useState("")
  const axios = useAxiosInstance();
  const [allOrg, setAllOrg] = useState([]);
  const [dashboardTiles, setDashboardTiles] = useState([]);
  const [isOrgLoading, setIsOrgLoading] = useState(false);
  const [isTilesLoading, setIsTilesLoading] = useState(false);
  const [overAllData, setOverAllData] = useState({});
  const { allOrganizations } = useSelector(e => e.globalAuth)
  const axiosInstance = useAxiosInstance();
  const [pinned_workflows, setpinned_workflows] = useState([])
  const [formData, setFormData] = useState({
    "user": {}
  });
  const [feature,setFeature] = useState({})

  useEffect(() => {
    if (orgPk !== "" || isAdmin !== "") {
      setIsTilesLoading(true);
      const controller = new AbortController();

      try {
        if (Object.keys(formData.user).length !== 0) {
          axiosInstance
            .get(`/accounts/user-preferences/?user__id=${Object.keys(formData.user)?.[0]}`)
            .then((res) => {
              setpinned_workflows(JSON.parse(JSON.stringify(res.data.pinned_workflows)))
              axios
                .post(`accounts/sandbox-dashboard/`, {
                  "org_pk": orgPk,
                  "is_admin": isAdmin
                }, {
                  signal: controller.signal
                })
                .then((res) => {
                  setIsTilesLoading(false);
                  setOverAllData(res)
                  setOrgName(res.data.org_pk)
                  setFeature(res?.data?.features?.newsletter||{})
                })
                .catch((err) => {
                  // toast.error("Bad Network");
                  setIsTilesLoading(false);
                });
            }).catch(err => {
              console.log(err)
            })
        } else {
          axios
            .post(`accounts/sandbox-dashboard/`, {
              "org_pk": orgPk,
              "is_admin": isAdmin
            }, {
              signal: controller.signal
            })
            .then((res) => {
              setIsTilesLoading(false);
              setOverAllData(res)
              setOrgName(res.data.org_pk)
              setFeature(res?.data?.features?.newsletter||{})
              setpinned_workflows([])
            })
            .catch((err) => {
              // toast.error("Bad Network");
              setIsTilesLoading(false);
            });
        }
      } catch (error) {
        console.error('Error fetching pinned workflows', error);
      }
      return () => {
        controller.abort();
      };
    }
  }, [orgPk, isAdmin, formData.user]);

  useEffect(() => {
    const data = overAllData?.data?.data;
    const features = overAllData?.data?.features;
    const _ = overAllData?.data?.report_categories || [];

    data?.forEach((tile) => (tile.tileType = 'report'));
    if (features && Object.keys(features)?.length) {
      const additionalTiles = Object.values(features);
      const codes = additionalTiles.map((e) => e.code);

      const alreadyInCards = data.find((e) => codes.includes(e.code));
      if (alreadyInCards) {
        alreadyInCards.tileType = 'feature';
      } else {
        additionalTiles.forEach((tile) => {
          tile.tileType = 'feature';
        });
        data.push(...additionalTiles);
      }
    }

    console.log(pinned_workflows)
    const orderMap = new Map(
      pinned_workflows.map((item) => [item.name, item.order])
    );

    const matchedItems = [];
    const remainingItems = [];

    data?.forEach((item) => {
      if (
        orderMap.has(item.code) &&
        !item.subscription.includes('Hidden')
      )
        matchedItems.push({ ...item, isPinned: true });
      else remainingItems.push(item);
    });

    matchedItems.sort((a, b) => {
      const orderA = orderMap.get(a.code) ?? 0;
      const orderB = orderMap.get(b.code) ?? 0;
      return orderA - orderB;
    });

    // console.log(matchedItems);

    let cardRes = [
      ...matchedItems,
      ...remainingItems.sort(
        (a, b) => a.order_preference - b.order_preference
      ),
    ];

    cardRes = cardRes.map((card) => {
      return {
        ...card,
        url: card.lexicalFeatures?.url
          ? card.lexicalFeatures?.url
          : `/dashboard/workflows/${card.code}`,
      };
    });
    setDashboardTiles(cardRes)
  }, [overAllData, pinned_workflows])

  const [searchParams, _] = useSearchParams()
  React.useEffect(() => {
    console.log(searchParams)
    const userParamOrgName = searchParams.get('org_pk')
    if (userParamOrgName) {
      setOrgPk(userParamOrgName)
    }
  }, [])

  const wokeloWorkflows = dashboardTiles?.filter((e) => !e.subscription.includes('Hidden')).filter(e => e.workflow_type === 'wokelo')
  const customWorkflows = dashboardTiles?.filter((e) => !e.subscription.includes('Hidden')).filter(e => e.workflow_type === 'custom')

  return (
    <div className="min-h-screen">
      <div className="p-6">
        <div className="flex justify-between mb-4">
          <div className="text-2xl font-semibold">Dashboard tiles</div>
          <div className="flex gap-3">
            <select
              className="border rounded-lg px-3 py-2 focus:ring-0 focus:outline-gray-400 disabled:bg-gray-300"
              value={isAdmin}
              onChange={(e) => {
                setIsAdmin(e.target.value)
              }}
            >
              <option value={false}>User view</option>
              <option value={true}>Admin view</option>
            </select>
            <div className="border rounded-lg px-3 py-2">Org : {allOrganizations.find(it => it.pk === orgPk)?.name}</div>{" "}
            <Select
              isLoading={isOrgLoading}
              className="w-[250px]"
              options={allOrganizations.map(it => {
                return { 'value': it.pk, "label": it.name }
              })}
              onChange={(e) => setOrgPk(e.value)}
            />
          </div>
        </div>

        <FormRender
          setFormData={setFormData}
          formData={formData}
          formSettings={[
            {
              label: "User*",
              type: "user",
              saveKey: "user",
            },
          ]}
          filterSettingsUserTable={{"changingValue":orgPk,"queryParams":"org_ids"}}
        />
        {isTilesLoading || isOrgLoading ? (
          <div className="w-full h-full flex justify-center items-center">
            <Spinner />
          </div>
        ) : (
          <div
            className={"flex flex-col w-full max-w-[1292px] m-0 sm:m-auto"}
          >
            <div className="border rounded-lg px-3 py-2">Org : {allOrganizations.find(it => it.pk == orgName)?.name}</div>
            <div className='flex items-center gap-x-3 max-w-[1292px] m-0 self-start px-0 sm:px-4'>
              <p className="text-2xl font-semibold font-Inter-Regular text-[#141416]  ">
                Wokelo workflows
              </p>
            </div>
            <div
              className={'flex flex-wrap gap-4 w-full p-4 px-0 sm:p-4'}>
              {wokeloWorkflows?.map((item, index) => {
                return (
                  <DashboardCardRound
                    item={item}
                    key={item?.name + index}
                    locked={false}
                  />
                );
              })}
            </div>
            <div className="mt-4 flex items-center gap-x-3 max-w-[1292px] m-0 self-start px-0 sm:px-4">
              <p className="text-2xl font-semibold font-Inter-Regular text-[#141416]  ">
                Custom workflows
              </p>
            </div>

            <div
              className={'flex flex-wrap gap-4 w-full p-4 px-0 sm:p-4'}>
              {customWorkflows?.filter((e) => !e.subscription.includes('Hidden'))?.map((item, index) => {
                return (
                  <DashboardCardRound
                    className='border border-[#EEEEEE]'
                    item={item}
                    key={item?.name + index}
                    locked={false}
                  />
                );
              })}
            </div>

            {Object.keys(feature).length!==0 && <>Newsletter visible :- <DashboardCardRound item={feature}/></>}
          </div>
        )}
      </div>
    </div>
  );
};

export default DashboardTiles;